import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_fat_projects = async (page, limit, keyword, groupBy) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/projects?page=${page}&limit=${limit}&keyword=${keyword}&groupBy=${groupBy}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_create_fat = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_update_fat = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fat_project_ships = async (projectId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/ship/${projectId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fat_list = async (page, limit, projectId, shipId, filterPayload) => {
    const baseUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat`;
    const queryParams = new URLSearchParams({
        projectId,
        page,
        limit,
        filterPayload
    });

    if (shipId) {
        queryParams.append('shipId', shipId);
    }

    const url = `${baseUrl}?${queryParams.toString()}`;

    return customAxios.get(url, getAuthHeader()).then((res) => res.data);
};


export const v3_fat_detail = async (fatId, filterPayload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/${fatId}?filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fat_documents = async (fatId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/documents/${fatId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_fat_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fat_comment_change_favourite_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/favouriteUnfavourite/comment`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_delete_fat_comment = async ({ fatId, commentId }) => {
    const queryParams = new URLSearchParams({ fatId });
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/comment/${commentId}?${queryParams.toString()}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_fat_Status_Update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/status`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fat_logs = async (fatId, page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat-logs?fatId=${fatId}&page=${page}&limit=${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_fat_comment_reply = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/comment/reply`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_fat_comment_replies = async (fatId, commentId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/comment/reply?fatId=${fatId}&commentId=${commentId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    });
};


export const v3_fat_comment_status_update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/comment/status`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};



export const v3_fat_send_report_mail = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/reportMail`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};
